
import { customInterIceptors } from '../../../lib/AxiosProvider';

const API = customInterIceptors();

export const getMainLink = (shortCode) => {
    return API.get(`/shortlink/${shortCode}`);
  };